import CommunityLoader from '@hulu-react-style-components/community-loader';
import styled, { css } from 'styled-components';

export const EmptyView = styled.div`
  font-family: InspireTWDC;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg1[1]};
  padding: ${({ theme }): string => theme.spacers!.spacer02} ${({ theme }): string => theme.spacers!.spacer04};
`;

export const StyledCheckboxWrapper = styled.div(
  ({ theme: { admanColors, spacers, colors } }) => css`
    padding-left: ${spacers!.spacer04};

    :hover {
      background: ${admanColors!.blue.dark.bg1[1]};
    }

    .TrekCheckbox-container {
      float: none;
      width: 100%;
      height: 40px;

      input + .TrekCheckbox-root {
        border: 1px solid ${admanColors!.gray.light.bg3[1]};
      }

      input:checked + .TrekCheckbox-root {
        background: ${admanColors!.blue.dark.bg1[0]};
        border: 1px solid ${admanColors!.blue.dark.bg1[0]};
      }

      input:checked {
        &:hover + .TrekCheckbox-root {
          background: ${admanColors!.blue.dark.bg2[0]};
          border: 1px solid ${admanColors!.blue.dark.bg2[0]};
        }
      }

      input:hover + .TrekCheckbox-root {
        border: 1px solid ${admanColors!.gray.light.fg1[2]};
      }

      .TrekLabel-root > span {
        font-family: InspireTWDC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        text-transform: none;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        max-width: 420px;
        letter-spacing: 0;
      }

      input:focused + .TrekCheckbox-root {
        box-shadow: 0 0 0 2px ${colors!.colorWhite}, 0 0 0 4px ${admanColors!.blue.light.bg1[1]};
        border: 1px solid ${admanColors!.blue.dark.bg2[1]};
      }

      input:active + .TrekCheckbox-root {
        background: ${admanColors!.blue.dark.bg2[1]};
        border: 1px solid ${admanColors!.blue.dark.bg2[1]};
      }

      input:hover + .TrekCheckbox-root::after,
      input:disabled + .TrekCheckbox-root::after {
        content: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC4yMDY2IDYuMDQyMzlDMjAuNTk3NCA2LjQzMjYzIDIwLjU5NzkgNy4wNjU4IDIwLjIwNzYgNy40NTY2TDkuNzIyNjcgMTcuOTU2NkM5LjUyOTI2IDE4LjE1MDMgOS4yNjQ5MSAxOC4yNTYyIDguOTkxMjcgMTguMjQ5N0M4LjcxNzYzIDE4LjI0MzIgOC40NTg2MiAxOC4xMjQ4IDguMjc0NjQgMTcuOTIyMUwzLjc1OTU5IDEyLjk0ODVDMy4zODgzNyAxMi41Mzk1IDMuNDE4OTQgMTEuOTA3MSAzLjgyNzg2IDExLjUzNTlDNC4yMzY3OSAxMS4xNjQ3IDQuODY5MjEgMTEuMTk1MiA1LjI0MDQzIDExLjYwNDJMOS4wNDk1NiAxNS44MDAyTDE4Ljc5MjQgNi4wNDM0QzE5LjE4MjcgNS42NTI2IDE5LjgxNTggNS42NTIxNCAyMC4yMDY2IDYuMDQyMzlaIiBmaWxsPSIjMDQwNDA1Ii8+Cjwvc3ZnPgo=);
        mask: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC4yMDY2IDYuMDQyMzlDMjAuNTk3NCA2LjQzMjYzIDIwLjU5NzkgNy4wNjU4IDIwLjIwNzYgNy40NTY2TDkuNzIyNjcgMTcuOTU2NkM5LjUyOTI2IDE4LjE1MDMgOS4yNjQ5MSAxOC4yNTYyIDguOTkxMjcgMTguMjQ5N0M4LjcxNzYzIDE4LjI0MzIgOC40NTg2MiAxOC4xMjQ4IDguMjc0NjQgMTcuOTIyMUwzLjc1OTU5IDEyLjk0ODVDMy4zODgzNyAxMi41Mzk1IDMuNDE4OTQgMTEuOTA3MSAzLjgyNzg2IDExLjUzNTlDNC4yMzY3OSAxMS4xNjQ3IDQuODY5MjEgMTEuMTk1MiA1LjI0MDQzIDExLjYwNDJMOS4wNDk1NiAxNS44MDAyTDE4Ljc5MjQgNi4wNDM0QzE5LjE4MjcgNS42NTI2IDE5LjgxNTggNS42NTIxNCAyMC4yMDY2IDYuMDQyMzlaIiBmaWxsPSIjMDQwNDA1Ii8+Cjwvc3ZnPgo=)
          no-repeat center / contain;
        mask: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC4yMDY2IDYuMDQyMzlDMjAuNTk3NCA2LjQzMjYzIDIwLjU5NzkgNy4wNjU4IDIwLjIwNzYgNy40NTY2TDkuNzIyNjcgMTcuOTU2NkM5LjUyOTI2IDE4LjE1MDMgOS4yNjQ5MSAxOC4yNTYyIDguOTkxMjcgMTguMjQ5N0M4LjcxNzYzIDE4LjI0MzIgOC40NTg2MiAxOC4xMjQ4IDguMjc0NjQgMTcuOTIyMUwzLjc1OTU5IDEyLjk0ODVDMy4zODgzNyAxMi41Mzk1IDMuNDE4OTQgMTEuOTA3MSAzLjgyNzg2IDExLjUzNTlDNC4yMzY3OSAxMS4xNjQ3IDQuODY5MjEgMTEuMTk1MiA1LjI0MDQzIDExLjYwNDJMOS4wNDk1NiAxNS44MDAyTDE4Ljc5MjQgNi4wNDM0QzE5LjE4MjcgNS42NTI2IDE5LjgxNTggNS42NTIxNCAyMC4yMDY2IDYuMDQyMzlaIiBmaWxsPSIjMDQwNDA1Ii8+Cjwvc3ZnPgo=)
          no-repeat center / contain;
        background-color: ${colors!.colorWhite};
        height: 16px;
        left: -1px;
        position: absolute;
        top: -1px;
        width: 16px;
      }

      input:disabled + .TrekCheckbox-root {
        background: ${admanColors!.gray.light.bg3[2]};
        border: 1px solid ${admanColors!.gray.light.bg3[2]};
      }

      .TrekLabel-root {
        margin-top: 0;
        margin-bottom: 0;
        height: 40px;
        padding: ${spacers!.spacer03} ${spacers!.spacer04} ${spacers!.spacer03} 0;
        flex-grow: 1;
      }
    }
  `
);

export const StyledWrapper = styled.div(
  ({ theme }) => css`
    padding: ${theme.spacers?.spacer03} 0;
    border-bottom: 1px solid ${theme.admanColors!.gray.light.bg3[0]};
  `
);

export const StyledListWrapper = styled.div`
  z-index: 200;
  position: relative;
`;

export const StyledInputFieldWrapper = styled.div(
  ({ theme }) => css`
    padding: ${theme.spacers!.spacer01} ${theme.spacers!.spacer04};
  `
);

export const StyledInputField = styled.input(
  ({ theme }) => css`
    border-radius: 8px;
    width: 100%;
    height: 32px;
    border: 1px solid ${theme.admanColors!.gray.light.bg3[0]};
    padding-left: ${theme.spacers!.spacer02};
    font-family: InspireTWDC;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;

    ::placeholder {
      font-family: InspireTWDC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
      color: ${theme.admanColors!.gray.light.fg1[2]};
    }
  `
);

export const StyledLink = styled.div`
  cursor: pointer;
  font-family: InspireTWDC;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  color: ${({ theme }): string => theme.admanColors!.blue.dark.bg1[0]};
  padding: ${({ theme }): string => theme.spacers!.spacer02} ${({ theme }): string => theme.spacers!.spacer04};
`;

export const StyledSelectRestrictions = styled.div(
  ({ theme: { admanColors, spacers } }) => css`
    color: ${admanColors!.gray.light.fg1[1]};
    font-family: InspireTWDC;
    font-size: 12px;
    font-style: italic;
    font-weight: 400;
    line-height: 18px;
    padding: 0 ${spacers?.spacer04} ${spacers?.spacer01};
  `
);

export const StyledDownloadMoreLoader = styled(CommunityLoader)`
  margin: ${({ theme }): string => theme.spacers!.spacer02} auto;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
`;

export const StyledDropdownContainer = styled.div(
  ({ theme: { spacers, admanColors } }) => css`
    position: absolute;
    background: white;
    z-index: 10;
    width: 100%;
    padding-bottom: ${spacers!.spacer01};
    border: 1px solid ${admanColors!.gray.dark.fg[1]};
    border-top: none;
    border-radius: 4px;
    min-height: 30px;
  `
);
